/* Public Methods Available For LRoot */
function Root(Base, store) {
  class NewRoot extends Base {

    goLink(to, tickItem = null) {
      const state = store.getState();
      state.storeRoute && state.storeRoute.goTo(to);
    }
    login(status) {
      const state = store.getState();
      if (state.storeAuth) {
        if (status === true) {
          state.storeAuth.welcome();
        }
        else if (status === false) {
          state.storeAuth.logout()
        }
      }
    }
    logout() {
      const state = store.getState();
      if (state.storeAuth) {
        state.storeAuth.logout();
      }
    }
  }
  return NewRoot;
}

export default Root;
